import axios from 'axios'
import { UserModel } from '../models/UserModel'

const isDev = (window.location.hostname.includes('localhost')
  || window.location.hostname.includes('dev-net.goplicity')
  || window.location.hostname.includes('amddev.sodexhochile.cl'))

const API_URL = isDev ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL_QAS
const API_URL_SAML = isDev ? process.env.REACT_APP_API_URL_SAML : process.env.REACT_APP_API_URL_SAML

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/Authenticate/verify_token`
export const LOGIN_URL = `${API_URL}/Authenticate/Login` //  `${API_URL}/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// Server should return AuthModel
// export function login(email: string, password: string) {
//   return axios.post(LOGIN_URL, {
//     email,
//     password,
//   })
// }

// Server should return AuthModel
export function login(user: string, password: string, Saml: string) {
  return axios.post(LOGIN_URL, {
    user,
    password,
    Saml
  })
}

export function saml(saml: string) {
  return axios.get(API_URL_SAML + "", {
    params: {
      SAMLRequest: saml,
      sso_reload: true
    }
  })
}

// Server should return AuthModel
export function register(email: string, firstname: string, lastname: string, password: string, password_confirmation: string) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, {
    email
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token
  })
}
